import { ActivityComponentType } from '@stackflow/react'
import { useQuery } from '@tanstack/react-query'
import useTranslation from '../../../modules/i18n/useTranslation'
import { fetchDetailBlogData } from '../../../pages/[lang]/student/landing/blog/[slug]'
import { useBlogStack } from '../../../pages/[lang]/webview/blog'
import BlogDetailResponsive from '../../landing/blog/Detail/BlogDetailResponsive'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface IBlogDetail {
  params: {
    slug: string
  }
}
const BlogDetailActivity: ActivityComponentType = ({ params }: IBlogDetail) => {
  const { locale } = useTranslation()
  const { useBlogFlow } = useBlogStack()
  const { pop } = useBlogFlow()
  const { data: post, isFetching } = useQuery({
    queryKey: ['blog_detail', params.slug, locale],
    queryFn: () => fetchDetailBlogData(params.slug, locale),
  })

  return (
    <WebviewStackContainer height="52px" onBack={pop}>
      {post && !isFetching && <BlogDetailResponsive post={post} isWebviewInitialValue={true} />}
    </WebviewStackContainer>
  )
}

export default BlogDetailActivity
